import { render, staticRenderFns } from "./NilaiPerolehanAsetComponent.vue?vue&type=template&id=d68d33ca&scoped=true"
import script from "./NilaiPerolehanAsetComponent.vue?vue&type=script&lang=js"
export * from "./NilaiPerolehanAsetComponent.vue?vue&type=script&lang=js"
import style0 from "./NilaiPerolehanAsetComponent.vue?vue&type=style&index=0&id=d68d33ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68d33ca",
  null
  
)

export default component.exports